export default {
  title: "Close Work Order",
  content:
    "Are you sure you want to close the selected <b class='text-info'>Work Order</b>? It is not completed.<br><br>This <b class='text-negative text-uppercase'>cannot</b> be undone.",
  label: "Closing comment",
}
